import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import {
  createUserWithEmailAndPassword,
  getAuth,
  signOut,
} from "firebase/auth";

import { addDoc, collection, doc, getFirestore } from "firebase/firestore";
import { toast } from "react-hot-toast";

const firebaseConfig = {
  apiKey: "AIzaSyAsrp2j9dZTlXEAqh90yUw8RLKG7NKvfSk",
  authDomain: "sayeagle-77c75.firebaseapp.com",
  databaseURL: "https://sayeagle-77c75-default-rtdb.firebaseio.com",
  projectId: "sayeagle-77c75",
  storageBucket: "sayeagle-77c75.appspot.com",
  messagingSenderId: "769020806835",
  appId: "1:769020806835:web:548d3230ea5dc8c8cf92c6",
  measurementId: "G-P5N3PBKVLZ",
};

const app = initializeApp(firebaseConfig);


const auth = getAuth(app);
const db = getFirestore(app);
export const storage = getStorage(app);
const registerWithEmailAndPassword = async (data) => {
  try {
    const res = await createUserWithEmailAndPassword(
      auth,
      data.email,
      data.password
    );
    const user = res.user;
    await addDoc(collection(db, "allUsers"), {
      uid: user.uid,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      companyName: data.companyName,
      role: "admin",
    });
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, data.companyName);
    const usersRef = collection(companyDocRef, "users");

      try {
        await addDoc(usersRef, { // use user.uid as the doc ID
          uid: user.uid,
          profile:{
           email:data.email,
           firstName:data.firstName,
           lastName:data.lastName,
           role:'admin'
         },
         phoneNumber:data.phoneNumber,
         companyDetails:{
           companyName:data.companyName,
           totalUnits:data.totalUnits.number
         }
       });
      toast.success("user created successfully");

      } catch (err) {
        toast.error(err.message);
      }
  } catch (err) {
    console.error(err);
    toast.error(err.message);
  }
};

const logout = () => {
  signOut(auth);
};
export { auth, db, logout, registerWithEmailAndPassword };
